
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"24","viewBox":"0 0 16 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.886 10.471C6.614 9.6 5.6 9.114 5.6 7.83c0-1.1.857-1.9 2.629-1.9 2.2 0 3.357 1.157 3.628 3.428l3.672-.486C15.257 5.171 13.357 3.13 10 2.63V0H6.629v2.614c-3.015.472-5.215 2.343-5.215 5.5 0 3.457 2.343 4.757 6.257 5.715 2.715.671 3.815 1.114 3.815 2.4 0 1.257-.929 1.914-2.743 1.914-2.486 0-3.743-1.1-3.872-3.486l-3.928.429c.157 3.857 2.5 5.771 5.686 6.328V24H10v-2.486c3.457-.385 5.7-2.428 5.7-5.585 0-3.286-2.314-4.515-5.814-5.458z","fill":"currentColor"}})])
          )
        }
      }
    